export enum RequestStatus {
  Idle = "idle",
  Pending = "pending",
  Rejected = "rejected",
  Fulfilled = "fulfilled",
}

// The duration we need to wait before sending a request to be sure the cache returns up to date data.
export const CacheTimeoutPeriod = 11000;
